document.addEventListener('DOMContentLoaded', () => {
    const form = document.querySelector('.cp-pass-edit__form');
    if (!form) return;

    const passwordInput = form.querySelector('#pass');
    const confirmInput = form.querySelector('#pass_confirm');
    const errorMessage = form.dataset.passwordMatchError || 'Пароли не совпадают';

    form.addEventListener('submit', (e) => {
        const confirmGroup = confirmInput.closest('.form-content__group');
        if (confirmGroup) {
            confirmGroup.classList.remove('error');
            const errorSpan = confirmGroup.querySelector('.form-content__error');
            if (errorSpan) errorSpan.textContent = '';
        }

        if (passwordInput.value !== confirmInput.value) {
            e.preventDefault();

            if (confirmGroup) {
                confirmGroup.classList.add('error');
                const errorSpan = confirmGroup.querySelector('.form-content__error');
                if (errorSpan) {
                    const msg = errorMessage.trim();
                    errorSpan.textContent = msg.startsWith('*') ? msg : `*${msg}`;
                }
            }
            confirmInput.focus();
        }
    });

    confirmInput.addEventListener('input', () => {
        if (passwordInput.value === confirmInput.value) {
            const confirmGroup = confirmInput.closest('.form-content__group');
            if (confirmGroup) {
                confirmGroup.classList.remove('error');
                const errorSpan = confirmGroup.querySelector('.form-content__error');
                if (errorSpan) errorSpan.textContent = '';
            }
        }
    });
});
